import { cloneElement, isValidElement, ReactElement, ReactNode } from 'react';
import CheckboxComponent from 'app/components/Checkbox/Checkbox';
import { TextM } from 'app/components/typography';
import { useTheme } from '@mui/material';
import {
  LoanGuaranteeCheckboxRow,
  LoanGuaranteeColumn,
  LoanGuaranteeInputWrapper,
} from '../CreditSimulatorV2/styles';

type LoanGuaranteeFieldColumnProps = {
  label: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  children?: ReactNode;
};

const LoanGuaranteeFieldColumn = ({
  label,
  checked,
  onToggle,
  children,
}: LoanGuaranteeFieldColumnProps) => {
  const theme = useTheme();
  const primaryColor = theme.palette.brand.primary.base;

  const renderInput = () => {
    if (!checked || !children) {
      return null;
    }

    if (isValidElement(children)) {
      return (
        <LoanGuaranteeInputWrapper>
          {cloneElement(children as ReactElement, {
            className: 'credit-simulator-fields',
          })}
        </LoanGuaranteeInputWrapper>
      );
    }

    return children;
  };

  return (
    <LoanGuaranteeColumn>
      <LoanGuaranteeCheckboxRow>
        <CheckboxComponent
          checked={checked}
          customcolor={primaryColor}
          sx={{
            color: primaryColor,
            '&.Mui-checked': {
              color: primaryColor,
            },
          }}
          onChange={(_, isChecked) => onToggle(isChecked)}
        />
        <TextM style={{ color: theme.palette.text.primary }}>{label}</TextM>
      </LoanGuaranteeCheckboxRow>
      {renderInput()}
    </LoanGuaranteeColumn>
  );
};

export default LoanGuaranteeFieldColumn;
